import {
  ACTION_LOAD_SITES_WITH_ALIASES__REQUEST,
  ACTION_LOAD_SITES_WITH_ALIASES__SUCCESS,
  ACTION_LOAD_SITES_WITH_ALIASES__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_SITES_WITH_ALIASES__REQUEST:
    case ACTION_LOAD_SITES_WITH_ALIASES__SUCCESS:
      return null;

    case ACTION_LOAD_SITES_WITH_ALIASES__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
